import { useState, MouseEvent } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { VideoType } from '../types';

interface VideoTypeMenuProps {
  videoType: VideoType;
  onVideoTypeChange: (type: VideoType) => void;
}

export const VideoTypeMenu = ({ videoType, onVideoTypeChange }: VideoTypeMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (type: VideoType) => {
    onVideoTypeChange(type);
    handleClose();
  };

  return (
    <>
      <IconButton id="video-type-button" onClick={handleClick} size="small" sx={{ fontSize: '10px' }}>
        <FilterListIcon />
      </IconButton>
      <Menu
        id="video-type-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'video-type-button',
        }}
      >
        <MenuItem onClick={() => handleSelect(VideoType.ALL)} selected={videoType === VideoType.ALL}>
          All
        </MenuItem>
        <MenuItem onClick={() => handleSelect(VideoType.VIDEOS)} selected={videoType === VideoType.VIDEOS}>
          Videos
        </MenuItem>
        <MenuItem onClick={() => handleSelect(VideoType.SHORTS)} selected={videoType === VideoType.SHORTS}>
          Shorts
        </MenuItem>
      </Menu>
    </>
  );
};
